import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";
import "@/store/store";

document
	.querySelectorAll(".wp-block-weather-weather-forecast-ten-days-search")
	.forEach((el) => {
		const root = el.querySelector(".weather-forecast-ten-days-search__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
